
    <app-lt-generic-grid-png #genericGridPng
        [data]="data()"
        [loading]="loading()"
        [customExport]="customExport()"
        [exportFileName]="exportFileName()"
        [columns]="columns()"
        [isReorderable]="isReorderable()"
        [isFilterable]="isFilterable()"
        [isResizeable]="isResizeable()"
        [isSelectable]="isSelectable()"
        [showSelectionColumn]="showSelectionColumn()"
        [showColumnMenu]="showColumnMenu()"
        [selectionfield]="selectionfield()"
        [showExportToolbar]="showExportToolbar()"
        [showChangeSelection]="showChangeSelection()"
        [enableAutoFit]="enableAutoFit()"
        [hasActionGoToColumn]="hasActionGoToColumn()"
        [actionGoToUsePrefix]="actionGoToUsePrefix()"
        [actionGoToField]="actionGoToField()"
        [actionGoToPrefix]="actionGoToPrefix()"
        [actionGoToFieldAddl]="actionGoToFieldAddl()"
        [actionGoToUseAddlField]="actionGoToUseAddlField()"
        [actionGoToUseSuffix]="actionGoToUseSuffix()"
        [actionGoToSuffix]="actionGoToSuffix()"
        [showSelectDeselectButtons]="showSelectDeselectButtons()"
        [selectionColumnWidth]="selectionColumnWidth()"
        [selectionColumnHeader]="selectionColumnHeader()"
        [overrideSelectedItem]="overrideSelectedItem()"
        (getUpdated)="onSelectionChange($event)"
        (itemSelected)="onSelectionChange($event)">
    </app-lt-generic-grid-png>
